import { render, staticRenderFns } from "./RejectExtraReviewDialog.vue?vue&type=template&id=39d96826&scoped=true&"
import script from "./RejectExtraReviewDialog.vue?vue&type=script&lang=js&"
export * from "./RejectExtraReviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d96826",
  null
  
)

export default component.exports